import { render, staticRenderFns } from "./recordother.vue?vue&type=template&id=febfed1c&scoped=true&"
import script from "./recordother.vue?vue&type=script&lang=js&"
export * from "./recordother.vue?vue&type=script&lang=js&"
import style0 from "./recordother.vue?vue&type=style&index=0&id=febfed1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febfed1c",
  null
  
)

export default component.exports